var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_133_28",
    "data-name": "Component 133 \\u2013 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
    fill: "none",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45150",
    "data-name": "Group 45150",
    transform: "translate(10.383 8.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45153",
    "data-name": "Group 45153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89635",
    "data-name": "Path 89635",
    d: "M2,6.36c-.007.126-.02.252-.02.378q0,6.1,0,12.2a2.36,2.36,0,0,0,.546,1.638,1.791,1.791,0,0,0,1.344.669c3.2.052,6.4.017,9.595.018A2.006,2.006,0,0,0,15.531,19.5a1.965,1.965,0,0,0,.036-.379q0-6.383,0-12.765",
    transform: "translate(-0.569 -0.773)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89636",
    "data-name": "Path 89636",
    d: "M15.478,6.189a1.155,1.155,0,0,0-.567-.128q-6.2,0-12.408,0a.511.511,0,0,0-.231.021c-.43.206-.766-.072-1.11-.237A1.19,1.19,0,0,1,.533,4.97a1.4,1.4,0,0,1,.941-1.658,1.3,1.3,0,0,1,.441-.064c.826,0,1.651,0,2.478,0a5.63,5.63,0,0,0,.567-.114c.191-.016.377.116.587.116q3.169-.009,6.341,0c.21,0,.4-.133.586-.116a5.649,5.649,0,0,0,.568.114c.8,0,1.61.022,2.414-.009a1.436,1.436,0,0,1,1.465,1.581,1.371,1.371,0,0,1-.839,1.126c-.189.087-.386.17-.584.239",
    transform: "translate(-0.5 -0.623)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89637",
    "data-name": "Path 89637",
    d: "M12.673,2.98a8.967,8.967,0,0,1-.02-.987A1.482,1.482,0,0,0,11.475.529a2,2,0,0,0-.5-.025C9.6.5,8.229.508,6.858.5a1.529,1.529,0,0,0-1.534.9,2.2,2.2,0,0,0-.122.84c-.014.245,0,.49,0,.735",
    transform: "translate(-0.718 -0.5)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89638",
    "data-name": "Path 89638",
    d: "M6.013,8.474q-.054,5.07,0,10.141",
    transform: "translate(-0.755 -0.871)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89639",
    "data-name": "Path 89639",
    d: "M9.1,8.474q.054,5.07,0,10.141",
    transform: "translate(-0.9 -0.871)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    y2: 10.141,
    transform: "translate(11.178 7.603)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e51cc60bee1d8deba8e1e80684774b38.svg";
export { ForwardRef as ReactComponent };